import { createFileRoute } from "@tanstack/react-router";
import type { SearchSchemaInput } from "@tanstack/react-router";
import { SectionPage } from "@/components/SectionPage";
import { RelatedHubs } from "@/components/RelatedHubs";
import { getSeoSectionItems } from "@/lib/seo.functions";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";

export const Route = createFileRoute("/fi/eat")({
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput): { q?: string; page?: number; lane?: string } => ({
    q: typeof search.q === "string" ? search.q : undefined,
    page: Number(search.page) > 0 ? Number(search.page) : 1,
    lane: typeof search.lane === "string" ? search.lane : undefined,
  }),
  loader: async () => {
    try {
      const { items } = await getSeoSectionItems({ data: { section: "eat", limit: 30 } });
      return { items };
    } catch {
      return { items: [] };
    }
  },
  head: ({ loaderData }) => {
    const items = loaderData?.items ?? [];
    const url = "https://whatfinland.com/fi/eat";
    const itemList = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Mitä syödä Suomessa — käsin valitut ravintolat, kahvilat ja baarit",
      url,
      inLanguage: "fi",
      numberOfItems: items.length,
      itemListElement: items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        url: `https://whatfinland.com/fi/place/${it.slug}`,
        name: it.name,
      })),
    };
    return {
      meta: [
        { title: "Mitä syödä Helsingissä — Ravintolat, Kahvilat ja Baarit" },
        { name: "description", content: "Käsin valitut ravintolat, kahvilat, baarit ja salaiset helmet Helsingissä — what Finland Oy:n suosittelemina." },
        { property: "og:title", content: "Mitä syödä — Helsinki" },
        { property: "og:description", content: "Helsingin parhaat pöydät, kahvilat ja baarit." },
        { property: "og:url", content: url },
        ...buildLocaleMeta("fi"),
      ],
      links: [
        { rel: "canonical", href: url },
        ...buildHreflangLinks("/fi/eat"),
      ],
      scripts: [{ type: "application/ld+json", children: JSON.stringify(itemList) }],
    };
  },
  component: () => (
    <>
      <SectionPage section="eat" />
      <RelatedHubs current="eat" />
    </>
  ),
});
